import { put, call, takeEvery } from 'redux-saga/effects';
import { axiosInstance, apiURL } from 'config';
import toast from 'react-hot-toast';

import {
  loadOrdersRequested,
  loadOrdersSuccess,
  loadOrdersFail,
  loadOrderRequested,
  loadOrderSuccess,
  loadOrderFail,
  updateStatusSuccess,
  updateStatusRequested,
  updateStatusFail,
  deleteOrderRequested,
  deleteOrderSuccess,
  deleteOrderFail,
  loadorderStatusesFail,
  loadorderStatusesRequested,
  loadorderStatusesSuccess,
} from './ordersSlice';
import {
  loadDashboardStatusCountEffect,
  loadOrdersDashboardEffect,
} from 'store/dashboard/sagas';

export function* loadOrdersEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.get,
      `${apiURL}/order-index?searchString=${
        action?.payload?.filters?.query ?? ''
      }&page=${action.payload.page}&pageSize=${action.payload.perPage}`
    );

    yield put(loadOrdersSuccess(data));
  } catch (error: any) {
    yield put(loadOrdersFail(error.message));
  }
}
export function* loadOrderByIdEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.get,
      `${apiURL}/get-order-by-id?Id=${action.payload.id}`
    );
    yield put(loadOrderSuccess(data));
  } catch (error: any) {
    yield put(loadOrderFail(error.message));
  }
}

function* updateStatusEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.post,

      `${apiURL}/order-status-change`,
      action?.payload
    );
    if (data?.succeeded) {
      yield put(updateStatusSuccess(data));
      yield call(loadOrderByIdEffect, {
        payload: {
          id: action?.payload?.orderId,
        },
        type: '',
      });
      yield call(loadOrdersDashboardEffect, {
        payload: {
          id: 0,
        },

        type: '',
      });

      yield call(loadDashboardStatusCountEffect, {
        payload: null,
        type: '',
      });

      toast.success('Order status updated successfully');
    } else {
      toast.error(data?.errors);
    }
  } catch (error: any) {
    yield put(updateStatusFail(error.message));
  }
}

export function* deleteOrderEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.delete,
      `${apiURL}/delete-order?Id=${action.payload.item.id}`
    );
    if (data?.succeeded) {
      yield put(deleteOrderSuccess(data));
      toast.success('Order deleted successfully');
    }
  } catch (error: any) {
    yield put(deleteOrderFail(error.message));
  }
}

export function* loadorderStatusesEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.get,
      `${apiURL}/get-delivery-status?`
    );
    yield put(loadorderStatusesSuccess(data));
  } catch (error: any) {
    yield put(loadorderStatusesFail(error.message));
  }
}

export function* ordersSaga(): Generator<any, void, any> {
  yield takeEvery(loadOrdersRequested, loadOrdersEffect);
  yield takeEvery(loadOrderRequested, loadOrderByIdEffect);
  yield takeEvery(updateStatusRequested, updateStatusEffect);
  yield takeEvery(deleteOrderRequested, deleteOrderEffect);
  yield takeEvery(loadorderStatusesRequested, loadorderStatusesEffect);
}
